import React, { useEffect } from "react";
import { Col, Container, Row, Stack } from "react-bootstrap";
import { Icon, Label, List } from "semantic-ui-react";
import Store from "../../assets/showroom/store";

const ContactPage = () => {
    const language = "id";

    const stores = Store(language);

    const priorityCities = ["Bandung", "Jakarta", "Tangerang", "Karawang"];

    const sortedStores = [...stores].sort((a, b) => {
        const aPriority = priorityCities.indexOf(a.city);
        const bPriority = priorityCities.indexOf(b.city);

        if (aPriority !== -1 && bPriority !== -1) {
            return aPriority - bPriority;
        }

        if (aPriority !== -1) return -1;
        if (bPriority !== -1) return 1;

        return a.city.localeCompare(b.city);
    });

    useEffect(() => {
        window.scrollTo(0, 0)
    })
    return (
        <>
            <section style={{ marginTop: "10rem", minHeight: "100vh", height: "100%" }}>
                <Container>
                    <Row className="d-flex justify-content-center mb-4">
                        <Col md={12}>
                            <div className="h2">Contact Information</div>
                            <div className="fs-5 text-muted" style={{ fontWeight: 'lighter' }}>
                                This is an information page about our location
                            </div>
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-center mb-3">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div className="contact-container">
                                <div className="contact-info">
                                    {/* <Stack direction="horizontal" gap={2} className="fs-3 mt-5 ms-5 pe-5">
                                        <div style={{ minWidth: '40px' }}><Icon circular name="map marker alternate" /></div>
                                        <Stack direction="vertical" gap={1}>
                                            <div className="ms-3 mb-2 fs-4">Address</div>
                                            <div className="ms-3 fs-5">Jl. Surapati No.61 Sadang Serang, Kecamatan Coblong.</div>
                                            <div className="ms-3 fs-5">Kota Bandung, Jawa Barat 40123</div>
                                        </Stack>
                                    </Stack> */}
                                    {/* <Stack direction="horizontal" gap={2} className="fs-3 mt-5 ms-5 pe-5">
                                        <div style={{minWidth:'40px'}}><Icon circular name="phone" /></div>
                                        <Stack direction="vertical" gap={1}>
                                            <div className="ms-3 mb-2 fs-4">Phone</div>
                                            <div className="ms-3 fs-5">022 - 2506999</div>
                                        </Stack>
                                    </Stack> */}
                                    {/* <Stack direction="horizontal" gap={2} className="fs-3 mt-5 ms-5 pe-5">
                                        <div style={{ minWidth: '40px' }}><Icon circular name="whatsapp" /></div>
                                        <Stack direction="vertical" gap={1}>
                                            <div className="ms-3 mb-2 fs-4">Whatsapp</div>
                                            <div className="ms-3 fs-5"><a href="https://wa.me/085220899946">0852-2089-9946</a></div>
                                        </Stack>
                                    </Stack> */}
                                    <Stack direction="horizontal" gap={1} className="fs-5 mt-5 ms-5 pe-5">
                                        <div style={{ minWidth: '40px' }}><Icon circular name="whatsapp" /></div>
                                        <Stack direction="vertical" gap={1}>
                                            <div className="ms-3 mb-2 fs-4">Whatsapp</div>
                                            <div className="ms-3 fs-5"><a href="https://wa.me/085220899946">0852-2089-9946</a></div>
                                        </Stack>
                                    </Stack>
                                </div>
                                {/* <div className="contact-map">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.9281060550725!2d107.61846207499623!3d-6.8992019931000454!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e68e7b14ffffffb%3A0x680778656c089b74!2sAdidas!5e0!3m2!1sid!2sid!4v1717579772630!5m2!1sid!2sid"
                                        width="100%" height="100%"
                                        className="contact-map-map"
                                    />
                                </div> */}
                            </div>
                        </Col>
                        <Col className="mt-5" xl={12} lg={12} md={12} sm={12}>
                            <Row className="justify-content-center">
                                {sortedStores.map((store, index) => (
                                    <Col
                                        key={index}
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        lg={4}
                                        xl={4}
                                        className="mb-4"
                                    >
                                        <div className="contact-container-child shadow-sm">
                                            <iframe
                                                src={store.map}
                                                width="100%"
                                                height="250"
                                                loading="lazy"
                                                referrerPolicy="no-referrer-when-downgrade"
                                                className="contact-map-map-child mb-2"
                                                style={{
                                                    borderRadius: "10px 10px 0 0",
                                                    border: "none"
                                                }}
                                            />
                                            <div className="contact-info-child p-3">
                                                <h6 className="fw-bold mb-2">{store.name}</h6>
                                                {/* <div style={{ color: "#fff" }}>
                                                    📍 {store.address}
                                                </div> */}
                                                <div style={{ color: "#fff" }}>
                                                    📞 {store.phone}
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section >
        </>
    )
}

export default ContactPage